import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { WarningIconBig } from '@rsmus/myrsm-icons'
import { Trans, useTranslation } from 'react-i18next'
import ResponsiveModal from '../../../rsmCoreComponents/components/ResponsiveModal'
import { Styles } from '../../../types'
import { useAppSelector } from '../../../utils/hooks'
import { getUserInfo } from '../../../store/userInfo/userInfoSlice'

interface PaymentNotAllowedDialogProps {
  open: boolean
  onClose: () => void
}

const styles: Styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '5%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxHeight: '100%',
    height: '100%',
  },
  title: {
    fontFamily: 'Prelo-Book, sans-serif',
    fontSize: '2.25rem',
    lineHeight: '2.5rem',
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  acceptWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexFlow: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1.5rem',
    paddingTop: '2rem',
    paddingBottom: '2rem',
  },
  notetext: {
    fontFamily: 'Prelo, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#515356',
    marginTop: '1rem',
  },
}

const PaymentNotAllowedDialog = ({
  open,
  onClose,
}: PaymentNotAllowedDialogProps) => {
  const { t } = useTranslation()
  const userInfo = useAppSelector(getUserInfo)

  return (
    <Box className="Rsm-ProfileModal">
      <ResponsiveModal
        open={open}
        onClose={onClose}
        aria-label={t('Invoicing.PaymentNotAllowedDialog.Title')}
        desktopMaxHeight="29rem"
        desktopMaxWidth="40rem"
        removeHeaderSpacing>
        <Box sx={styles.dialogContent}>
          <WarningIconBig />
          {/* PlaceHolder for Title */}
          {/* <Typography variant="h1" sx={styles.title}>
            {t('Invoicing.PaymentNotAllowedDialog.Title')}
          </Typography> */}
          <Typography sx={styles.notetext}>
            <Trans
              i18nKey={
                userInfo.isEmployee
                  ? 'Invoicing.PaymentNotAllowedDialog.AccountManagementMessage'
                  : 'Invoicing.PaymentNotAllowedDialog.DashboardMessage'
              }
              components={{ b: <b /> }}
            />
          </Typography>
          <Stack sx={styles.acceptWrapper}>
            <Button variant="outlined" onClick={onClose}>
              {t('Invoicing.PaymentNotAllowedDialog.Cancel')}
            </Button>
          </Stack>
        </Box>
      </ResponsiveModal>
    </Box>
  )
}

export default PaymentNotAllowedDialog
